import React, { useEffect, useState, useRef } from "react";
import { Box, Typography, Grid } from "@mui/material";
import { apiCallUserUploadedPhotos } from "../../../../Core/Apicall";
import { useLocation } from "react-router-dom";
import UserProfileMediaList from "../userProfileMedia"


const PublicUserClickTab: React.FC = () => {
  const [photos, setPhotos] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(9);
  const [totalCount, setTotalCount] = useState(0);

  const [openPreview, setOpenPreview] = useState(false);
  const [selectedVenue, setSelectedVenue] = useState<any | null>(null);

  const scrollRef = useRef<HTMLDivElement | null>(null);
  const location = useLocation();
  const userData = location.state.user;

  const fetchData = async (userId: any) => {
    setLoading(true);
    try {
      const res = await apiCallUserUploadedPhotos({
        userId,
        offset: 1,
        limit: rowsPerPage,
      });
      setPhotos(res.data || []);
      setTotalCount(res.totalCount || 0);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData(userData.userId ? userData.userId : userData._id);
  }, [userData, rowsPerPage]);

  const handleOpenVenueGallery = (item: any) => {
    setSelectedVenue(item);
    setOpenPreview(true);
  };

  return (
    <Grid container>
      <Box sx={{ p: 2, width: "100%" }}>
        <UserProfileMediaList
          venueName={userData.venueName}
          userId={userData._id}
        />
      </Box>
    </Grid>
  );



};

export default PublicUserClickTab;
